export default "__VITE_ASSET__DgiAlQl0__"